import React, { useState, useEffect } from 'react';
import { ReviewInbox } from '../components/recovery/ReviewInbox';
import authenticatedFetch from '../utils/authenticatedFetch';
import { API_ENDPOINTS } from '../config/apiRouting';

const RecoveryPage: React.FC = () => {
  const [selectedStore, setSelectedStore] = useState<string>('');
  const [storeName, setStoreName] = useState<string>('');
  const [stores, setStores] = useState<any[]>([]);

  useEffect(() => {
    loadStores();
  }, []);

  const loadStores = async () => {
    try {
      // Use recovery my-stores endpoint which returns only user's permitted stores
      const res = await authenticatedFetch(API_ENDPOINTS.recoveryMyStores());
      if (res.ok) {
        const data = await res.json();
        const storeList = data.stores || data || [];
        if (storeList.length > 0) {
          setStores(storeList);
          setSelectedStore(storeList[0].storeId);
          setStoreName(storeList[0].name || 'Store');
        }
      }
    } catch (e) {
      console.error('Failed to load stores', e);
    }
  };

  const handleStoreChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const storeId = e.target.value;
    setSelectedStore(storeId);
    const store = stores.find(s => s.storeId === storeId);
    setStoreName(store?.name || 'Store');
  };

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 700, margin: 0 }}>Recovery</h1>
        {stores.length > 1 && (
          <select
            value={selectedStore}
            onChange={handleStoreChange}
            style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
          >
            {stores.map(s => (
              <option key={s.storeId} value={s.storeId}>{s.name}</option>
            ))}
          </select>
        )}
      </div>

      {selectedStore && (
        <ReviewInbox storeId={selectedStore} storeName={storeName} />
      )}
    </div>
  );
};

export default RecoveryPage;
